import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/e/$identifier")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/events/$identifier",
      params: { identifier: params.identifier },
    });
  },
});
